export enum NOTIFICATION_TYPES {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
  SUCCESS = 'success',
  ATTENTION = 'attention',
  INFO_NO_BG_COLOR = 'infoNoBgColor',
}
